var BlimpExtPricehistory = new Class({
	Extends: BlimpExt,

	post_process_build: function () {
		var _table = this._element.getElement('.w_pricehistory_table') || this._element.getElement('.w_pricehistory_fullscreen_table');;
		var tbody = _table.getElement('.tbody');

		if (this.is_initialized) {
			return;
		}

		if (this.options.page === 'lst' || this.options.vscroll) {
			new StyledScroll(tbody, {
				type: 'v',
				max_height: 300
			});
		}

		var _diagram = this._element.getElement('.diagram');

		if (_diagram) {
			_diagram.setStyle('height', _table.getSize().y);

			var data = JSONMOO.decode(_diagram.get('html'), false);

			_diagram.set('html', '');

			new Phgraph(_diagram, {
				'size': 'small',
				'data': data.reverse() // need to reverse the order so it will be display properly in the chart
			});
		}

		this.parent();
		this.is_initialized = true;
	}

});
